import _classCallCheck from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { addDomEvent } from '../events/add-dom-event.mjs';
import { Feature } from '../motion/features/Feature.mjs';
import { pipe } from '../utils/pipe.mjs';
var FocusGesture = /*#__PURE__*/function (_Feature) {
  _inherits(FocusGesture, _Feature);
  var _super = _createSuper(FocusGesture);
  function FocusGesture() {
    var _this;
    _classCallCheck(this, FocusGesture);
    _this = _super.apply(this, arguments);
    _this.isActive = false;
    return _this;
  }
  _createClass(FocusGesture, [{
    key: "onFocus",
    value: function onFocus() {
      var isFocusVisible = false;
      /**
       * If this element doesn't match focus-visible then don't
       * apply whileHover. But, if matches throws that focus-visible
       * is not a valid selector then in that browser outline styles will be applied
       * to the element by default and we want to match that behaviour with whileFocus.
       */
      try {
        isFocusVisible = this.node.current.matches(":focus-visible");
      } catch (e) {
        isFocusVisible = true;
      }
      if (!isFocusVisible || !this.node.animationState) return;
      this.node.animationState.setActive("whileFocus", true);
      this.isActive = true;
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      if (!this.isActive || !this.node.animationState) return;
      this.node.animationState.setActive("whileFocus", false);
      this.isActive = false;
    }
  }, {
    key: "mount",
    value: function mount() {
      var _this2 = this;
      this.unmount = pipe(addDomEvent(this.node.current, "focus", function () {
        return _this2.onFocus();
      }), addDomEvent(this.node.current, "blur", function () {
        return _this2.onBlur();
      }));
    }
  }, {
    key: "unmount",
    value: function unmount() {}
  }]);
  return FocusGesture;
}(Feature);
export { FocusGesture };